import { createFourierModel } from "./model";
import { cat } from "./shapes/cat";

export const catModel = createFourierModel(cat);
